import { render, staticRenderFns } from "./klistwithoverflow.vue?vue&type=template&id=16a38479&scoped=true"
import script from "./klistwithoverflow.vue?vue&type=script&lang=js"
export * from "./klistwithoverflow.vue?vue&type=script&lang=js"
import style0 from "./klistwithoverflow.vue?vue&type=style&index=0&id=16a38479&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a38479",
  null
  
)

export default component.exports